import {
  SEARCH_TARGET,
  COMPANY_SEARCH_TYPE,
  RESULT_CODE,
  CREATE_FILE_PROCESS_KBN,
  PROCESS_STATUS,
  HIERARCHY_KBN,
  DOWNLOAD_TARGET,
  FUNC_TYPE,
} from '../../common/const';
import config from '../../common/config';
import {
  requestApi,
  API_END_POINT,
} from '../../common/api';
import { getMessage } from '../../common/util';
import {
  ERROR,
} from '../../common/message';
import {
  setErrorMessage,
  getDispItem,
} from './CommonAction';

/**
 * state初期化のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INIT_COMPANY_STATE = 'COMPANY/SET_INIT_COMPANY_STATE';

/**
 * state初期化
 */
export const setInitCompanyState = () => ({
  type: SET_INIT_COMPANY_STATE,
});

/**
 * 取引情報リストの表示フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDITIONAL_ITEM_FLG = 'COMPANY/SET_ADDITIONAL_ITEM_FLG';

/**
  * 取引情報リストの表示フラグ設定
  * @param   {boolean} additionalItemFlg 取引情報リストの表示フラグ
  */
export const setAdditionalItemFlg = (additionalItemFlg) => (
  { type: SET_ADDITIONAL_ITEM_FLG, additionalItemFlg }
);

/**
 * 取引情報リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDITIONAL_ITEM_LIST = 'COMPANY/SET_ADDITIONAL_ITEM_LIST';

/**
  * 取引情報リスト設定
  * @param   {object} additionalItemList 取引情報リスト
 */
export const setAdditionalItemList = (additionalItemList = {}) => (
  { type: SET_ADDITIONAL_ITEM_LIST, additionalItemList }
);

/**
 * QuickSearchの入力文字設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEARCH_CONDITION = 'COMPANY/SET_SEARCH_CONDITION';
/**
 * QuickSearchの入力文字設定
 * @param   {string} searchCondition QuickSearchの入力文字
 */
export const setSearchCondition = (searchCondition) => (
  { type: SET_SEARCH_CONDITION, searchCondition }
);

/**
 * 検索条件詳細の表示フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_QUICK_SEARCH_FLG = 'COMPANY/SET_QUICK_SEARCH_FLG';
/**
 * 検索条件詳細の表示フラグ設定
 * @param   {boolean} quickSearchFlg 検索条件詳細の表示フラグ
 */
export const setQuickSearchFlg = (quickSearchFlg) => (
  { type: SET_QUICK_SEARCH_FLG, quickSearchFlg }
);

/**
 * 検索条件詳細（検索対象）の選択値設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEARCH_TARGET = 'COMPANY/SET_SEARCH_TARGET';
/**
 * 検索条件詳細（検索対象）の選択値設定
 * @param   {string} searchTarget 検索条件詳細（検索対象）の選択値
 */
export const setSearchTarget = (searchTarget) => (
  { type: SET_SEARCH_TARGET, searchTarget }
);

/**
 * 検索条件詳細（地域設定）の選択値設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_AREA_CONFIG = 'COMPANY/SET_AREA_CONFIG';
/**
 * 検索条件詳細（地域設定）の選択値設定
 * @param   {string} areaConfig 検索条件詳細（地域設定）の選択値
 */
export const setAreaConfig = (areaConfig) => (
  { type: SET_AREA_CONFIG, areaConfig }
);

/**
 * QuickSearch(検索結果一覧)の表示フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_QUICK_SEARCH_RESULT_FLG = 'COMPANY/SET_QUICK_SEARCH_RESULT_FLG';
/**
 * QuickSearch(検索結果一覧)の表示フラグ設定
 * @param   {boolean} quickSearchResultFlg QuickSearch(検索結果一覧)の表示フラグ
 */
export const setQuickSearchResultFlg = (quickSearchResultFlg) => (
  { type: SET_QUICK_SEARCH_RESULT_FLG, quickSearchResultFlg }
);

/**
 * 現在ページ番号設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_NOWPAGE = 'COMPANY/SET_NOWPAGE';

/**
  * 現在ページ番号設定
  * @param   {number}  nowpage  現在ページ番号
  */
export const setNowPage = (nowpage) => ({
  type: SET_NOWPAGE, nowpage,
});

/**
 * 取引情報ポップアップの現在ページ番号設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDITIONAL_ITEM_PAGE = 'COMPANY/SET_ADDITIONAL_ITEM_PAGE';

/**
   * 取引情報ポップアップの現在ページ番号設定
   * @param   {number}  additionalItemPage  現在ページ番号
   */
export const setAdditionalItemPage = (additionalItemPage) => ({
  type: SET_ADDITIONAL_ITEM_PAGE, additionalItemPage,
});

/**
 * 取引情報ポップアップの選択対象設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDITIONAL_ITEM_TARGET = 'COMPANY/SET_ADDITIONAL_ITEM_TARGET';

/**
    * 取引情報ポップアップの選択対象設定
    * @param   {number}  additionalItemTarget  選択対象
    */
export const setAdditionalItemTarget = (additionalItemTarget) => ({
  type: SET_ADDITIONAL_ITEM_TARGET, additionalItemTarget,
});

/**
 * 拠点情報の表示フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_BASE_INFO_FLG = 'COMPANY/SET_BASE_INFO_FLG';
/**
 * 拠点情報の表示フラグ設定
 * @param   {boolean} baseInfoFlg 拠点情報の表示フラグ
 */
export const setBaseInfoFlg = (baseInfoFlg) => (
  { type: SET_BASE_INFO_FLG, baseInfoFlg }
);

/**
 * 企業情報の表示フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COMPANY_INFO_FLG = 'COMPANY/SET_COMPANY_INFO_FLG';
/**
 * 企業情報の表示フラグ設定
 * @param   {boolean} companyInfoFlg 企業情報の表示フラグ
 */
export const setCompanyInfoFlg = (companyInfoFlg) => (
  { type: SET_COMPANY_INFO_FLG, companyInfoFlg }
);

/**
 * 企業情報一覧設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COMPANY_RESULT_LIST = 'COMPANY/SET_COMPANY_RESULT_LIST';
/**
 * 企業情報一覧設定
 * @param   {object} companyResultList 企業検索結果一覧
 */
export const setCompanyResultList = (companyResultList = {}) => (
  { type: SET_COMPANY_RESULT_LIST, companyResultList }
);

/**
 * 企業情報設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COMPANY_INFO = 'COMPANY/SET_COMPANY_INFO';
/**
 * 企業情報設定
 * @param   {object} companyInfo 企業情報（拠点情報、企業情報）
 */
export const setCompanyInfo = (companyInfo = {}) => (
  { type: SET_COMPANY_INFO, companyInfo }
);

/**
 * 選択中企業情報設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SELECTED_COMPANY_INFO = 'COMPANY/SET_SELECTED_COMPANY_INFO';
/**
 * 選択中企業情報設定
 * @param   {object} selectedCompanyInfo 選択中企業情報
 */
export const setSelectedCompanyInfo = (selectedCompanyInfo = {
  duns: null,
  kigyo_code: null,
  trade_name: null,
  office_code: null,
  id: null,
}) => (
  { type: SET_SELECTED_COMPANY_INFO, selectedCompanyInfo }
);

/**
 * ダウンロードオプション表示フラグの設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DOWNLOAD_INFO_FLG = 'COMPANY/SET_DOWNLOAD_INFO_FLG';
/**
 * ダウンロードオプション表示フラグの設定
 * @param   {boolean} downloadConditionFlg ダウンロードオプションの表示フラグ
 * @param   {boolean} downloadLimitOverFlg ダウンロード件数超過確認フラグ
 * @param   {boolean} downloadLimitOverMessage ダウンロード件数超過確認メッセージ
 */
export const setDownloadConditionFlg = (
  downloadConditionFlg,
  downloadLimitOverFlg = false,
  downloadLimitOverMessage = null,
) => (
  {
    type: SET_DOWNLOAD_INFO_FLG,
    downloadConditionFlg,
    downloadLimitOverFlg,
    downloadLimitOverMessage,
  }
);

/**
 * ダウンロードオプション（ダウンロード対象）の選択値設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DOWNLOAD_TARGET = 'COMPANY/SET_DOWNLOAD_TARGET';
/**
 * ダウンロードオプション（ダウンロード対象）の選択値設定
 * @param   {string[]} selectValArray ダウンロード条件（ダウンロード対象）の選択値設定
 */
export const setDownloadTarget = (selectValArray = []) => (
  { type: SET_DOWNLOAD_TARGET, download_target: selectValArray }
);

/**
 * ダウンロードオプション（ダウンロードする項目）の選択値設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DOWNLOAD_CONFIG = 'COMPANY/SET_DOWNLOAD_CONFIG';
/**
 * ダウンロードオプション（ダウンロードする項目）の選択値設定
 * @param   {string} selectVal ダウンロード条件（ダウンロードする項目）の選択値
 */
export const setDownloadConfig = (selectVal) => (
  { type: SET_DOWNLOAD_CONFIG, download_config: selectVal }
);

/**
 * ダウンロードステータス情報の設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DOWNLOAD_STATUS_INFO = 'COMPANY/SET_DOWNLOAD_STATUS_INFO';
/**
 * ダウンロードステータス情報の設定
 * @param   {object} downloadStatusInfo ダウンロードステータス情報
 */
export const setDownloadStatusInfo = (downloadStatusInfo = {}) => (
  { type: SET_DOWNLOAD_STATUS_INFO, downloadStatusInfo }
);

/**
 * ポーリングID設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_POLLING_ID = 'COMPANY/SET_POLLING_ID';
/**
 * ポーリングID設定
 * @param   {number} pollingId ポーリングID
 */
export const setPollingId = (pollingId) => (
  { type: SET_POLLING_ID, pollingId }
);

/**
 * 階層情報区分値の設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_HIERARCHY_KBN = 'COMPANY/SET_HIERARCHY_KBN';
/**
 * 階層情報区分値の設定
 * @param   {string} hierarchyKbn 階層情報区分値
 */
export const setHierarchyKbn = (hierarchyKbn) => (
  { type: SET_HIERARCHY_KBN, hierarchyKbn }
);

/**
* 非公開フラグの設定のAction識別文字列
* @type    {string}  Action識別文字列
*/
export const SET_BLIND_FLG = 'COMPANY/SET_BLIND_FLG';
/**
* 非公開フラグの設定
* @param   {boolean} blindFlg 非公開フラグ
*/
export const setBlindFlg = (blindFlg) => (
  { type: SET_BLIND_FLG, blindFlg }
);

/**
* 国内親会社リンク非表示フラグの設定のAction識別文字列
* @type    {string}  Action識別文字列
*/
export const SET_PARENTS_LINK_BLIND_FLG = 'COMPANY/SET_PARENTS_LINK_BLIND_FLG';
/**
* 国内親会社リンク非表示フラグの設定
* @param   {boolean} parentsLinkBlindFlg 国内親会社リンク非表示フラグ
*/
export const setParentsLinkBlindFlg = (parentsLinkBlindFlg) => (
  { type: SET_PARENTS_LINK_BLIND_FLG, parentsLinkBlindFlg }
);

/**
* 国内最上位親会社リンク非表示フラグの設定のAction識別文字列
* @type    {string}  Action識別文字列
*/
export const SET_ROOT_LINK_BLIND_FLG = 'COMPANY/SET_ROOT_LINK_BLIND_FLG';
/**
* 国内最上位親会社リンク非表示フラグの設定
* @param   {boolean} rootLinkBlindFlg 非表示情報フラグ
*/
export const setRootLinkBlindFlg = (rootLinkBlindFlg) => (
  { type: SET_ROOT_LINK_BLIND_FLG, rootLinkBlindFlg }
);

/**
* 地域階層タブ非表示フラグの設定のAction識別文字列
* @type    {string}  Action識別文字列
*/
export const SET_AREA_HIERARCHY_FLG = 'COMPANY/SET_AREA_HIERARCHY_FLG';
/**
* 地域階層タブ非表示フラグの設定
* @param   {boolean} areaHierarchyFlg 地域階層タブ非表示フラグ
*/
export const setAreaHierarchyFlg = (areaHierarchyFlg) => (
  { type: SET_AREA_HIERARCHY_FLG, areaHierarchyFlg }
);

/**
 * 企業階層情報の設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_COMPANY_HIERARCHY_INFO_LIST = 'COMPANY/SET_COMPANY_HIERARCHY_INFO_LIST';
/**
 * 企業階層情報の設定
 * @param   {object} resultList 企業階層情報
 */
export const setCompanyHierarchyInfoList = (companyHierarchyInfoList = {}) => (
  { type: SET_COMPANY_HIERARCHY_INFO_LIST, companyHierarchyInfoList }
);

/**
 * 地域リスト情報設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_AREA = 'COMPANY/SET_AREA';
/**
 * 地域リスト情報設定
 * @param   {object} areaList 地域リスト情報
 */
export const setArea = (areaList) => (
  { type: SET_AREA, areaList }
);

/**
 * 拡張項目001有無フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_EXT_001_FLG = 'COMPANY/SET_EXT_001_FLG';
/**
 * 拡張項目001有無有無フラグ設定
 * @param   {string} tradeDetailFlg 拡張項目001有無有無フラグ
 */
export const setExt001Flg = (ext001Flg = null) => (
  { type: SET_EXT_001_FLG, ext001Flg }
);

/**
 * 拡張項目001有無フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_EXT_002_FLG = 'COMPANY/SET_EXT_002_FLG';
/**
 * 拡張項目001有無有無フラグ設定
 * @param   {string} ext002Flg 拡張項目001有無有無フラグ
 */
export const setExt002Flg = (ext002Flg = null) => (
  { type: SET_EXT_002_FLG, ext002Flg }
);

/**
 * 取引情報会社名設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDITIONAL_COMPANY = 'COMPANY/SET_ADDITIONAL_COMPANY';
/**
 * 取引情報会社名設定
 * @param   {string} additionalCompany 取引情報会社名設定
 */
export const setAdditionalCompany = (additionalCompany = null) => (
  { type: SET_ADDITIONAL_COMPANY, additionalCompany }
);

/**
 * 取引情報事業所名設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ADDITIONAL_JIGYOSYO = 'COMPANY/SET_ADDITIONAL_JIGYOSYO';
/**
 * 取引情報事業所名設定
 * @param   {string} additionalJigyosyo 取引情報事業所名
 */
export const setAdditionalJigyosyo = (additionalJigyosyo = null) => (
  { type: SET_ADDITIONAL_JIGYOSYO, additionalJigyosyo }
);

/**
 * 企業情報一覧検索
 * ・検索条件を元に企業情報を検索
 * ・検索結果を一時保存領域に保持
 * @param   {string}  searchCondition  クイック検索条件（画面入力値）
 * @param   {number}  page ページ番号
 */
export const searchCompanyList = (searchCondition, page) => async (dispatch, getState) => {
  // 一時保存領域から、検索条件（QuickSearch(詳細設定)）を取得
  const { quickSearchCondition } = getState().company;
  const o = {};
  if (quickSearchCondition.search_target === SEARCH_TARGET.DUNS) {
    // DUNS検索の場合
    o.duns = searchCondition;
  } else if (quickSearchCondition.search_target === SEARCH_TARGET.KIGYO_CODE) {
    // TSRコード検索の場合
    o.kigyo_code = searchCondition;
  } else if (quickSearchCondition.search_target === SEARCH_TARGET.CORPORATE_NUMBER) {
    // 法人番号検索の場合
    o.corporate_number = searchCondition;
  } else {
    // 企業名検索の場合
    o.company_name = searchCondition;
    if (quickSearchCondition.search_target === SEARCH_TARGET.COMPANY_NAME) {
      o.company_search_type = COMPANY_SEARCH_TYPE.PARTIAL;
    } else {
      o.company_search_type = COMPANY_SEARCH_TYPE.PERFECT;
    }
  }
  if (quickSearchCondition.area_config.length > 0) {
    // 地域設定
    o.area_config = quickSearchCondition.area_config;
  }

  // 取得上限
  o.limit_count = config.SEARCH_LIMIT_COUNT.COMPANY;

  // ページ番号
  o.page_no = page;

  // 企業情報取得APIへリクエストを送信
  const ret = await requestApi(dispatch, API_END_POINT.SEARCH_COMPANY_LIST_SINGLE, o);

  // 取得件数0件の場合、一覧を空にする
  if (ret.result === RESULT_CODE.NOT_FOUND) {
    dispatch(setCompanyResultList());
    return true;
  }
  // エラーの場合、メッセージを設定し一覧を空にする
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    dispatch(setCompanyResultList());
    return false;
  }
  // 検索結果を一時保存領域へ保存
  dispatch(setCompanyResultList(ret.response));
  if (page == null) {
    dispatch(setNowPage(1));
  } else {
    dispatch(setNowPage(page));
  }
  // スクロールを先頭に戻す
  const ele = document.querySelector('.searchresultlist .resultlist');
  if (ele !== null) {
    ele.scrollTo(0, 0);
  }
  return true;
};

/**
  * 事業所情報詳細取得
  * ・事業所コードの値を元に事業所情報を検索
  * ・検索結果を一時保存領域に保持
  * @param   {string}  officeCode  事業所コード
  */
export const searchCompanyOfficeInfo = (officeCode) => async (dispatch) => {
  // 検索条件作成
  const o = {
    office_code: officeCode,
  };

  // 事業所情報詳細取得APIへリクエストを送信
  const ret = await requestApi(dispatch, API_END_POINT.GET_OFFICE_DETAIL, o);
  // エラーの場合、メッセージ設定を行う
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    // 企業情報設定を初期化
    const resDispItem = await dispatch(getDispItem());
    dispatch(setCompanyInfo(resDispItem));
    return false;
  }
  // 検索結果を一時保存領域へ保存
  dispatch(setCompanyInfo(ret.response));
  return true;
};

/**
  * 事業所情報詳細取得(ライト版)
  * ・事業所コードの値を元に事業所情報を検索
  * ・検索結果を返却する
  * @param   {string}  officeCode  事業所コード
  */
export const searchCompanyOfficeInfoLight = (officeCode) => async (dispatch) => {
  // 検索条件作成
  const o = {
    office_code: officeCode,
  };

  // 事業所情報詳細取得APIへリクエストを送信
  const ret = await requestApi(dispatch, API_END_POINT.GET_OFFICE_DETAIL, o);
  // エラーの場合、メッセージ設定を行う
  if (ret.result === RESULT_CODE.ERROR) {
    dispatch(setErrorMessage(ret.response));
    return ret;
  }
  return ret;
};

/**
  * 取引情報一覧取得
  * ・事業所コードの値を元に取引情報一覧を検索
  * ・検索結果を一時保存領域に保持
  * @param   {string}  officeCode  事業所コード
  */
export const searchAdditionalItemList = (item) => async (dispatch) => {
  // 検索条件作成
  const o = {};

  // 事業所コード
  o.office_code = item.office_code;

  // 取得上限
  o.limit_count = config.SEARCH_LIMIT_COUNT.ADDITIONAL_ITEM;

  // ページ番号
  // 設定なし

  // 事業所情報詳細取得APIへリクエストを送信
  const ret = await requestApi(dispatch, API_END_POINT.GET_ADDITIONAL_ITEM_LIST, o);
  // エラーの場合、メッセージ設定を行う
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    // 取引情報一覧を初期化
    dispatch(setAdditionalItemList());
    return false;
  }

  // 検索結果を一時保存領域へ保存
  dispatch(setAdditionalItemList(ret.response));
  dispatch(setAdditionalItemTarget(item.officeCode));
  dispatch(setAdditionalCompany(item.trade_informal_name));
  if (item.office_name) {
    dispatch(setAdditionalJigyosyo(item.office_name));
  } else {
    dispatch(setAdditionalJigyosyo('本社'));
  }
  dispatch(setExt001Flg(item.search_flag_001));
  dispatch(setExt002Flg(item.search_flag_002));
  dispatch(setAdditionalItemTarget(item.office_code));
  dispatch(setAdditionalItemPage(1));
  dispatch(setAdditionalItemFlg(true));
  // スクロールを先頭に戻す
  const ele = document.querySelector('.additionalitemlist .listfield tbody');
  if (ele !== null) {
    ele.scrollTo(0, 0);
  }
  return true;
};

/**
  * 取引情報一覧取得(ページング)
  * ・事業所コードの値を元に取引情報一覧を検索
  * ・検索結果を一時保存領域に保持
  * @param   {string}  officeCode  事業所コード
  */
export const searchAdditionalItemListPaging = (officeCode, page) => async (dispatch) => {
  // 検索条件作成
  const o = {};

  // 事業所コード
  o.office_code = officeCode;

  // 取得上限
  o.limit_count = config.SEARCH_LIMIT_COUNT.ADDITIONAL_ITEM;

  // ページ番号
  o.page_no = page;

  // 事業所情報詳細取得APIへリクエストを送信
  const ret = await requestApi(dispatch, API_END_POINT.GET_ADDITIONAL_ITEM_LIST, o);
  // エラーの場合、メッセージ設定を行う
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    // 取引情報一覧を初期化
    dispatch(setAdditionalItemList());
    return false;
  }

  // 検索結果を一時保存領域へ保存
  dispatch(setAdditionalItemList(ret.response));
  dispatch(setAdditionalItemPage(page));
  dispatch(setAdditionalItemFlg(true));
  // スクロールを先頭に戻す
  const ele = document.querySelector('.additionalitemlist .listfield tbody');
  if (ele !== null) {
    ele.scrollTo(0, 0);
  }
  return true;
};

/**
  * 事業所情報一覧取得
  * ・企業コードを元に事業所情報一覧を検索
  * ・検索結果を一時保存領域に保持
  * @param   {string}  kigyoCode  企業コード
  */
export const searchCompanyOfficeList = (kigyoCode) => async (dispatch) => {
  // 検索条件作成
  const o = {
    kigyo_code: kigyoCode,
  };
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_OFFICE_LIST, o);
  // エラーの場合、メッセージ設定を行う
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    // 企業階層情報を初期化
    dispatch(setCompanyHierarchyInfoList());
    // 選択中企業情報を初期化
    dispatch(setSelectedCompanyInfo());
    return false;
  }

  // レスポンスに対象企業が存在しない場合、
  if (ret.response.kigyo_code && kigyoCode !== ret.response.kigyo_code) {
    dispatch(setErrorMessage(getMessage(ERROR.E00004)));
    // 企業階層情報を初期化
    dispatch(setCompanyHierarchyInfoList());
    // 選択中企業情報を初期化
    dispatch(setSelectedCompanyInfo());
    return false;
  }

  // 企業階層情報
  dispatch(setCompanyHierarchyInfoList(ret.response));

  const selectedCompanyInfoVal = {
    duns: ret.response.duns,
    kigyo_code: ret.response.kigyo_code,
    trade_name: ret.response.trade_name,
    office_code: ret.response.office_code,
    id: null,
  };
  // 選択中企業情報の一時保存領域を更新
  dispatch(setSelectedCompanyInfo(selectedCompanyInfoVal));

  return true;
};

/**
  * 事業所一覧検索
  * ・企業コードを元に、事業所一覧を検索
  * ・検索結果を一時保存領域に保持
  * @param   {string}  kigyoCode  企業コード
  * @param   {number}  level  階層
  */
export const searchTreeOfficeList = (kigyoCode, level) => async (dispatch, getState) => {
  // 検索条件作成
  const o = {
    kigyo_code: kigyoCode,
  };
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_OFFICE_LIST, o);
  let officeList = null;
  // エラーの場合、nullを返す
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
  } else if (ret.result === RESULT_CODE.SUCCESS) {
    officeList = ret.response.child_list;
  }
  const { companyHierarchyInfoList } = getState().company;
  // 取得した事業所一覧情報を、一時保存領域の企業階層ツリーから検索した対象の企業コードの事業所一覧配列に設定
  if (level === 1) {
    if (companyHierarchyInfoList.kigyo_code === kigyoCode) {
      // 親会社の事業所リストに設定
      companyHierarchyInfoList.office_list = officeList;
    }
  } else if (level === 2) {
    if (companyHierarchyInfoList.child_list === undefined) {
      return false;
    }
    companyHierarchyInfoList.child_list.some((child, i) => {
      // 子会社の企業コードと比較
      if (child.kigyo_code === kigyoCode) {
        // 子会社の事業所リストに設定
        companyHierarchyInfoList.child_list[i].office_list = officeList;
        return true;
      }
      return false;
    });
  } else if (level === 3) {
    if (companyHierarchyInfoList.child_list === undefined) {
      return false;
    }
    companyHierarchyInfoList.child_list.some((child, i) => {
      if (child.child_list && child.child_list.length > 0) {
        // 孫会社リストがある場合
        child.child_list.some((grandchild, j) => {
          // 孫会社の企業コードと比較
          if (grandchild.kigyo_code === kigyoCode) {
            // 孫会社の事業所リストに設定
            companyHierarchyInfoList.child_list[i].child_list[j].office_list = officeList;
            return true;
          }
          return false;
        });
        return true;
      }
      return false;
    });
  }
  dispatch(setCompanyHierarchyInfoList(companyHierarchyInfoList));
  return true;
};

/**
  * 企業階層検索
  * ・企業コードを元に、企業階層検索（タブ：出資率50%超）
  * ・検索結果を一時保存領域に保持
  * @param   {string}  kigyoCode  企業コード
  */
export const searchCompanyHierarchyList = (kigyoCode) => async (dispatch) => {
  // 検索条件作成
  const o = {
    kigyo_code: kigyoCode,
  };
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_COMPANY_HIERARCHY, o);
  // エラーの場合、メッセージ設定を行う
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    // 企業階層情報を初期化
    dispatch(setCompanyHierarchyInfoList());
    // 選択中企業情報を初期化
    dispatch(setSelectedCompanyInfo());
    return false;
  }

  let selectDuns;
  let selectKigyoCode;
  let selectTradeName;
  let selectOfficeCode;
  // 親会社の企業企業コードと比較
  if (ret.response.kigyo_code === kigyoCode) {
    // 親会社を選択中企業に設定
    selectDuns = ret.response.duns;
    selectKigyoCode = ret.response.kigyo_code;
    selectTradeName = ret.response.trade_name;
    selectOfficeCode = ret.response.office_code;
  } else if (ret.response.child_list) {
    ret.response.child_list.some((child) => {
      // 子会社の企業企業コードと比較
      if (child.kigyo_code === kigyoCode) {
        // 子会社を選択中企業に設定
        selectDuns = child.duns;
        selectKigyoCode = child.kigyo_code;
        selectTradeName = child.trade_name;
        selectOfficeCode = child.office_code;
        return true;
      }
      return false;
    });
  }

  // レスポンスに対象企業が存在しない場合
  if (!selectKigyoCode) {
    dispatch(setErrorMessage(getMessage(ERROR.E00004)));
    // 企業階層情報を初期化
    dispatch(setCompanyHierarchyInfoList());
    // 選択中企業情報を初期化
    dispatch(setSelectedCompanyInfo());
    return false;
  }

  // 企業階層情報
  dispatch(setCompanyHierarchyInfoList(ret.response));

  const selectedCompanyInfo = {
    duns: selectDuns,
    kigyo_code: selectKigyoCode,
    trade_name: selectTradeName,
    office_code: selectOfficeCode,
    id: null,
  };
  // 選択中企業情報の一時保存領域を更新
  dispatch(setSelectedCompanyInfo(selectedCompanyInfo));

  return true;
};

/**
  * 地域階層情報検索
  * ・企業コードの値を元に、地域階層情報検索を行う
  * ・検索結果を一時保存領域に保持
  * @param   {string}  kigyoCode  企業コード
  */
export const searchAreaHierarchyList = (kigyoCode) => async (dispatch) => {
  // 検索条件作成
  const o = {
    kigyo_code: kigyoCode,
  };
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_AREA_HIERARCHY, o);
  // エラーの場合、メッセージ設定を行う
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    // 企業階層情報を初期化
    dispatch(setCompanyHierarchyInfoList());
    // 選択中企業情報を初期化
    dispatch(setSelectedCompanyInfo());
    return false;
  }

  // レスポンスに対象企業が存在しない場合、
  if (ret.response.kigyo_code && kigyoCode !== ret.response.kigyo_code) {
    dispatch(setErrorMessage(getMessage(ERROR.E00004)));
    // 企業階層情報を初期化
    dispatch(setCompanyHierarchyInfoList());
    // 選択中企業情報を初期化
    dispatch(setSelectedCompanyInfo());
    return false;
  }

  // 企業階層情報
  dispatch(setCompanyHierarchyInfoList(ret.response));

  const selectedCompanyInfoVal = {
    duns: ret.response.duns,
    kigyo_code: ret.response.kigyo_code,
    trade_name: ret.response.trade_name,
    office_code: ret.response.office_code,
    id: null,
  };
  // 選択中企業情報の一時保存領域を更新
  dispatch(setSelectedCompanyInfo(selectedCompanyInfoVal));

  return true;
};

/**
 * ダウンロードステータス取得
 * ・取得したステータスが処理中の場合、TRUEを返却
 */
export const checkDownloadStatus = () => async (dispatch) => {
  // 検索条件作成
  const o = {
    process_type: CREATE_FILE_PROCESS_KBN.DOWNLOAD_POSSIBLE,
  };
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.CREATE_COMPANY_OFFICE_FILE_CODE, o);
  // ネットワークエラーの場合
  if (ret.result === RESULT_CODE.ANOMALY) {
    dispatch(setErrorMessage(ERROR.E09013));
    dispatch(setDownloadStatusInfo());
    return false;
  }

  // 認証エラーの場合は何も設定しない
  if (ret.result === RESULT_CODE.ERROR && ret.response === null) {
    return false;
  }

  // エラーの場合、ダウンロードステータス情報を初期化
  if (ret.result === RESULT_CODE.ERROR) {
    await dispatch(setErrorMessage(ERROR.E09015));
    dispatch(setDownloadStatusInfo());
    return false;
  }
  // ダウンロードステータス情報を更新
  dispatch(setDownloadStatusInfo(ret.response));

  // ステータスが処理中かどうかを返却
  return ret.response.status === PROCESS_STATUS.PROCESSING;
};

/**
  * ポーリング処理停止
  */
export const stopDownloadPolling = () => (dispatch, getState) => {
  const { pollingId } = getState().company;
  // ポーリングIDが設定されている場合、ポーリング処理停止
  if (pollingId) {
    clearInterval(pollingId);
    dispatch(setPollingId());
  }
};

/**
  * ポーリング処理開始
  */
export const startDownloadPolling = () => (dispatch) => {
  const pollingId = setInterval(async () => {
    const res = await dispatch(checkDownloadStatus());
    if (!res) {
      // ダウンロードステータスが処理中以外の場合、ポーリング処理を停止
      dispatch(stopDownloadPolling());
    }
  }, config.DOWNLOAD_POLLING.COMPANY_DOWNLOAD);
  dispatch(setPollingId(pollingId));
};

/**
  * CSVファイル作成リクエスト
  */
export const createDownloadFile = () => async (dispatch, getState) => {
  const {
    downloadCondition,
    hierarchyKbn,
    companyHierarchyInfoList,
    downloadLimitOverFlg,
  } = getState().company;

  // 検索条件作成
  const o = {
    // 処理区分:ファイル作成
    process_type: CREATE_FILE_PROCESS_KBN.CREATE_FILE,
  };

  if (downloadLimitOverFlg) {
    // 件数確認区分
    o.count_conf_type = '1';
  }

  if (downloadCondition.download_target
    && downloadCondition.download_target.length > 0) {
    // ダウンロード対象リスト
    o.download_target_list = downloadCondition.download_target;
  }

  // ダウンロード項目
  o.download_value = downloadCondition.download_config;

  const codeList = [];
  codeList.push(companyHierarchyInfoList.kigyo_code);
  if (hierarchyKbn === HIERARCHY_KBN.FUND
    && companyHierarchyInfoList.child_list
    && companyHierarchyInfoList.child_list.length > 0) {
    // 出資率50%超かつ子会社が存在する場合
    companyHierarchyInfoList.child_list.forEach((child) => {
      // 子会社の企業コードを追加
      codeList.push(child.kigyo_code);
      if (child.child_list && child.child_list.length > 0) {
        // 孫会社が存在する場合
        child.child_list.forEach((grandchild) => {
          // 孫会社の企業コードを追加
          codeList.push(grandchild.kigyo_code);
        });
      }
    });
  }
  // 企業コードリスト
  o.code_list = codeList;

  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.CREATE_COMPANY_OFFICE_FILE_CODE, o);

  if (ret.result === RESULT_CODE.WARN) {
    // ダウンロード件数が超過件数を超えた場合、件数超過フラグとメッセージを設定
    dispatch(setDownloadConditionFlg(true, true, ret.response[0]));
  } else if (ret.result === RESULT_CODE.NOT_FOUND) {
    // 取得件数0件の場合、ダウンロードステータスを初期化
    if (downloadCondition.download_target.includes(DOWNLOAD_TARGET.MFP)) {
      // ダウンロード対象に「MFPのみ」が設定されている場合、エラーメッセージを設定
      dispatch(setErrorMessage(getMessage(ERROR.E02003)));
    }
    dispatch(setDownloadStatusInfo());
    dispatch(setDownloadConditionFlg(false));
  } else if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーの場合、メッセージ設定、ダウンロードステータスを初期化
    dispatch(setErrorMessage(ret.response));
    dispatch(setDownloadStatusInfo());
    dispatch(setDownloadConditionFlg(false));
  } else {
    // 正常終了の場合、ダウンロードステータス情報を更新、ポーリング処理開始
    dispatch(setDownloadStatusInfo(ret.response));
    dispatch(setDownloadConditionFlg(false));
    await dispatch(startDownloadPolling());
  }
};

/**
  * CSVファイルダウンロード
  */
export const fileDownloadExecute = () => async (dispatch, getState) => {
  const o = {};
  o.function_type = FUNC_TYPE.COMPANY_DOWNLOAD;
  // API実行
  const ret = await requestApi(dispatch, API_END_POINT.UPDATE_EXCLUDE_FLG, o);
  // エラーが発生した場合
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    return false;
  }
  // ダウンロード処理
  const downLoadLink = document.createElement('a');
  document.body.appendChild(downLoadLink);
  downLoadLink.href = `${config.API_PROTOCOL}://${config.API_HOST}/${config.DOWNLOAD_PATH}/${getState().company.downloadStatusInfo.file_name}`;
  downLoadLink.click();

  // ダウンロードステータスを初期化
  dispatch(setDownloadStatusInfo());

  return true;
};
